import _Vue, { PluginObject } from 'vue';
import Vuex from 'vuex';
import VeeValidatePlugin from 'vee-validate';

import initUIKit from 'ux1-ui-kit';

import { allPlugins, DevFlagsPlugin } from './vue-plugins';
import { configCommonModules } from '@/Common/Utils/General/Modules';
import { $t } from '@/Framework/app/translate';
import { getTranslatePlugin } from './vue-plugins';

import getStore from '@/HostApp/store';

interface ISetPlugins extends Host.IDevFlags {
	Vue: Host.IInitFWWithEnvOptions['Vue'];
	t: Host.IInitFWWithEnvOptions['t'];
	locale: Host.IInitFWWithEnvOptions['locale'];
	isHost?: Host.IInitFWWithEnvOptions['isHost'];
}

const setConfig = (Vue: Host.IInitFWWithEnvOptions['Vue'], config: Host.IInitFWWithEnvOptions['configVue']): void => {
	Object.keys(config).forEach((key: string) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(Vue.config as any)[key] = (config as any)[key];
	});
};
const setPlugins = ({ Vue, t, locale, isHost = false, isLocalDev, isHostDevMode }: ISetPlugins): void => {
	// Vendors plugins
	Vue.use(Vuex);
	Vue.use(VeeValidatePlugin, {
		classes: true,
		errorBagName: 'errorsVee', // change if property conflicts
		fieldsBagName: 'fieldsVee'
	});

	// Ux1's plugins
	allPlugins.forEach((plugin: PluginObject<null>) => Vue.use(plugin));
	Vue.use(getTranslatePlugin(t));
	Vue.use(DevFlagsPlugin, { isLocalDev, isHostDevMode });

	// Apply default store
	Vue.mixin({ store: getStore(isHost) });

	initUIKit(Vue, locale);

	configCommonModules(locale);
};

const prepareEnv = ({
	Vue = _Vue,
	configVue = {},
	t = $t,
	locale = 'en',
	isHost,
	isLocalDev = false,
	isHostDevMode = false
}: Partial<Host.IInitFWWithEnvOptions> = {}): void => {
	setConfig(Vue, configVue);
	setPlugins({ Vue, t, locale, isHost, isLocalDev, isHostDevMode });
};

export default prepareEnv;
